import { render, staticRenderFns } from "./EvaluationWizard.vue?vue&type=template&id=2f2bae22&scoped=true&"
import script from "./EvaluationWizard.vue?vue&type=script&lang=js&"
export * from "./EvaluationWizard.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationWizard.vue?vue&type=style&index=0&id=2f2bae22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bae22",
  null
  
)

export default component.exports